import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { GrupoUsuarioModel, ModelSearch, DataTablesRequest } from 'projects/ProjetoBaseAngular/domain/models';
import { BaseCrudComponent } from 'projects/ProjetoBaseAngular/app/base-crud.component';
import { GrupoUsuarioModalComponent } from './grupo-usuario-modal/grupo-usuario-modal.component';
import { GrupoUsuarioService } from 'projects/ProjetoBaseAngular/domain/services';
import { OptionSearchType, SearchType } from 'projects/ProjetoBaseAngular/domain/types';

@Component({
  selector: 'app-grupo-usuarios',
  templateUrl: './grupo-usuarios.component.html',
})
export class GrupoUsuariosComponent extends BaseCrudComponent<GrupoUsuarioModel> implements OnInit {
  @ViewChild('grupoUsuarioModal') modal: GrupoUsuarioModalComponent;

  search = new ModelSearch('nome', OptionSearchType.Contains, SearchType.String);

  selectColumns = [
    { data: 'nome' }
  ];

  constructor(
    injector: Injector,
    readonly grupoUsuarioService: GrupoUsuarioService
  ) {
    super(injector, grupoUsuarioService);
  }

  protected beforeDtRequest(dataTablesParameters: DataTablesRequest): DataTablesRequest {
    const searches = [];
    (this.search.searchTerm) && searches.push(this.search);

    dataTablesParameters.searches = searches;
    return super.beforeDtRequest(dataTablesParameters);
  }

  ngOnInit() {
    super.ngOnInit();    
  }
}
